// downloadFileHook.ts
export const useDownloadFile = () => {
    const downloadFile = async (options: { documentId: string; token: string; documentName: string }) => {
      const { documentId, token, documentName } = options;

      const downloadUrl = `${(window as any)?.REACT_APP_API_URL}FileUpload/Download/${documentId}`;
      
      const headers = new Headers({
        Authorization: `Bearer ${token}`,
      });
  
      try {
        const response = await fetch(downloadUrl, { headers });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        // Create a Blob from the response
        const blob = await response.blob();
  
        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = documentName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    };
  
    return { downloadFile };
  };
  